import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

export class BankAccountSourceForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        dataApiName: 'BankAccountSource', primaryKey: 'id', text: 'Kilder',
        allowEdit: true, allowCreate: true, allowDelete: true, 
        baseFields: ['id', 'history']
      },
      fieldMetadata:
        [
          { name: 'bankAccount', text: 'Bankkonto', foreignKeyTableName: 'BankAccount' },
          { name: 'source', text: 'Transaktionskilde', foreignKeyTableName: 'BankAccountTransactionSource' },
          { name: 'address', text: 'Data sti' },
          { name: 'active', text: 'Aktiv', format: 'CheckBox' },
        ]
    });
  }
}
